import { TeamRole } from '@anm/api/modules/team';
import { ModalProps } from '@anm/components/modals/Modal';
import { capitalize } from 'lodash/fp';
import { useState, FC } from 'react';
import { UserTeamPermission } from 'types/user';

import TeamRolesForm from '../../TeamRolesForm';
import { TeamRolesFormFields } from '../../TeamRolesForm/index';
import { InvitationItemInputProps } from '../InvitationItem';

import { Item, LeftSide, List, Name, RightSide, Role, TeamModalWrapper } from './Wrapper';

export type RoleChange = { userId: string; role: TeamRole };
export type TeamRolesModalProps = Pick<ModalProps, 'onModalClose'> & {
  userId: string;
  currentUserId?: string;
  isPending: boolean;
  list: InvitationItemInputProps[];
  onRoleChange: (props: RoleChange) => void;
  permissions?: UserTeamPermission;
};

const TeamRolesModal: FC<TeamRolesModalProps> = ({
  userId,
  list,
  currentUserId,
  isPending,
  permissions,
  onRoleChange,
  onModalClose
}) => {
  const getCurrentInvite = (id: string) => list.find(item => id === item.userId);

  const [localInviteId, setLocalInviteId] = useState(userId);
  const { userName, role: currentRole } = getCurrentInvite(localInviteId) || {};

  const handleSubmit = ({ role }: TeamRolesFormFields) => role && onRoleChange({ userId: localInviteId, role });

  if (!currentRole) return null;

  return (
    <TeamModalWrapper title="Team roles" onModalClose={onModalClose}>
      <LeftSide>
        <List>
          {list.map(
            ({ userId, role, userName }) =>
              (role !== 'OWNER' || userId === currentUserId) && (
                <Item
                  key={userId}
                  isActive={localInviteId === userId}
                  onClick={() => userId && setLocalInviteId(userId)}
                >
                  <Name>{userName}</Name>
                  <Role>
                    {capitalize(role)} {currentUserId === userId ? '(you)' : ''}
                  </Role>
                </Item>
              )
          )}
        </List>
      </LeftSide>
      <RightSide>
        <TeamRolesForm
          initialValues={{ role: currentRole }}
          currentRole={currentRole}
          nextOwnerName={userName!}
          permissions={permissions}
          isPending={isPending}
          onClose={onModalClose}
          onSubmit={handleSubmit}
        />
      </RightSide>
    </TeamModalWrapper>
  );
};

export default TeamRolesModal;
